import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { GetAllDistributionSystems } from './distribution-systems.actions';
import { IdistributionSystems } from '../../core/interfaces/distribution-systems.interface';
import { HttpService } from '../../core/services/http/http.service';

export interface DistributionSystemsStateModel {
  distributionSystems: IdistributionSystems[];
}

@State<DistributionSystemsStateModel>({
  name: 'distributionSystems',
  defaults: {
    distributionSystems: [],
  },
})
@Injectable()
export class DistributionSystemsState {
  @Selector() static GetAllData(
    state: DistributionSystemsStateModel
  ): IdistributionSystems[] {
    return state?.distributionSystems ? state?.distributionSystems : [];
  }

  constructor(private httpService: HttpService) {}

  @Action(GetAllDistributionSystems)
  async GetAllDistributionSystems(
    ctx: StateContext<DistributionSystemsStateModel>
  ) {
    try {
      const resp = await this.httpService.getDistributionSystems();
      if (resp && resp.length) {
        ctx.patchState({
          distributionSystems: resp,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  }
}
